export const authQueryKeys = {
  all: ['auth'] as const,

  currentUserProfile: () =>
    [...authQueryKeys.all, 'currentUserProfile'] as const,
};
